import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import gb from "./languages/gb.json";
import de from "./languages/de.json";

export const resources = {
  gb: {
    translation: gb,
  },

  de: {
    translation: de,
  },
};

i18n.use(initReactI18next).init({
  compatibilityJSON: "v4",
  resources,
  // If the user previously selected a language we store it under either
  // the i18next default key (i18nextLng) or the app-specific 'language' key.
  // Load that here so the choice persists across refreshes.
  lng: (() => {
    try {
      return (
        localStorage.getItem("i18nextLng") || localStorage.getItem("language") || undefined
      );
    } catch (e) {
      return undefined;
    }
  })(),
  defaultNS: "translation",
  fallbackLng: "gb",
});

export default i18n;

// Ensure the HTML document <html lang> attribute reflects the chosen language.
// Map the project key 'gb' to the standard 'en' value used in the lang attribute.
try {
  const initialKey = i18n.language || localStorage.getItem("i18nextLng") || localStorage.getItem("language") || "gb";
  const docLang = initialKey === "gb" ? "en" : initialKey;
  if (typeof document !== "undefined" && docLang) {
    document.documentElement.setAttribute("lang", docLang);
  }
} catch (e) {
  // ignore in non-browser environments or if access to localStorage fails
}
